import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { CookieService } from 'ngx-cookie-service';
import { AttorneyUserModel } from "src/app/_shared/models/attorney-user.model";

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnInit, OnDestroy {

  private _isAuthenticated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _token$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private _holdAttemptedUrl: string;
  private _barNumber: string;
  private _user$: BehaviorSubject<AttorneyUserModel> = new BehaviorSubject<AttorneyUserModel>(null);

  private _authKey: number = 0;

  set attemptedUrl(val: string){
    //console.log('set url=' + val);
    this._holdAttemptedUrl = val;
  }

  get attemptedUrl(): string {
    return this._holdAttemptedUrl;
  }

  set token(val: string){
    //console.log('set token', val);
    this._token$.next(val);
    if(val){
      this._isAuthenticated$.next(true);
      localStorage.setItem('token', val);
    } else {
      this._isAuthenticated$.next(false);
      localStorage.removeItem('token');
    }
  }

  getToken(): Observable<string> {
    return this._token$.asObservable();
  }

  set isAuthenticated(val: boolean){
    this._isAuthenticated$.next(val);
  }

  getIsAuthenticated(): Observable<boolean> {
    if (this._user$.value) {
      this._isAuthenticated$.next(true);
    }
    return this._isAuthenticated$.value ? this._isAuthenticated$.asObservable() : of(false);
    //return this._isAuthenticated$.asObservable();
  }

  set barNumber(val: string){
    this._barNumber = val;;
  }

  get barNumber(): string {
    //console.log('get barNumber', this._barNumber);
    return this._user$.value ? this._user$.value.barNumber : this._barNumber;
  }

  set user(val: AttorneyUserModel){
    if (val) {
      //console.log('set user', val);
      localStorage.setItem('user', JSON.stringify(val));
      this._user$.next(val);
      this._barNumber = val.barNumber;
    } else {
      localStorage.removeItem('user');
      this._barNumber = '';
    }

  }

  getUser(): Observable<AttorneyUserModel> {
    return this._user$.asObservable();
  }

  clearUser() {
    this._user$.next(null);
    localStorage.removeItem('user');
    this._isAuthenticated$.next(false);
    this._token$.next('');
    localStorage.removeItem('token');
    this.cookieService.deleteAll('/', 'sbga.atsservices.net', false, 'Lax');
  }

  constructor(private cookieService: CookieService) {
    this._authKey = Math.floor(Math.random() * (500 - 1 + 1) + 1)

    var currentDateTime = new Date();

    var user = JSON.parse(localStorage.getItem('user'));
    const expires = new Date(user?.expires);

    //console.log('auth service constructor', user);
    if (user && (expires?.getTime() > currentDateTime?.getTime())) {
      const expires = new Date(user.expires);
      this._user$ = new BehaviorSubject<AttorneyUserModel>(user);
      this._isAuthenticated$.next(true);
      this._token$ = new BehaviorSubject<string>(localStorage.getItem('token'));
    }

  }

  ngOnInit(): void {
    //console.log('auth service init');

  }

  ngOnDestroy(): void {
    //console.log('auth service destroy');
  }

}

